module.exports = __webpack_public_path__ + "static/media/overallaccuracy.73c8a3f7.png";